/**
 * i18n helper — NL-only.
 *
 * De app is per <2026-03> vast Nederlands. De vertaling-runtime is bewust
 * behouden zodat de bestaande call-sites (`useT`, `useLang`, `tf`) onveranderd
 * blijven, maar de translator is nu een identiteit-functie: elke string komt
 * er ongewijzigd uit. Zo hoefden we niet duizend `t("...")`-calls te
 * verwijderen. Als in de toekomst een tweede taal terug moet komen, kan de
 * oude EN-map uit git-history worden hersteld en de switch weer toegevoegd.
 */

// Deprecated shims — voor achterwaartse compatibiliteit met code die
// `useLang()` gebruikte om de huidige taal of setter op te halen. Sinds
// NL-only geeft `setLang` een no-op terug en is `t` een identiteits-functie.
export const useLang = () => ({ lang: "nl", setLang: () => {}, t: (s) => s });

export const useT = () => (s) => s;

export const LanguageProvider = ({ children }) => {
  // Zet <html lang="nl"> voor screenreaders en browser-hints. Slechts één keer
  // per mount — geen re-render trigger nodig.
  if (typeof document !== "undefined") {
    document.documentElement.lang = "nl";
  }
  return children;
};

/**
 * Template-helper — vervangt `{key}` tokens in een string.
 * Voorheen combineerde deze functie vertaling + interpolatie; sinds NL-only
 * doet hij alleen nog de interpolatie, maar de signature blijft `(t, tpl, vars)`
 * zodat alle bestaande aanroepen blijven werken.
 */
export function tf(t, template, vars = {}) {
  let out = t(template);
  Object.entries(vars).forEach(([k, v]) => {
    out = out.replaceAll(`{${k}}`, String(v));
  });
  return out;
}
